import api from './api';

// Anonyme Session-ID holen
const getAnonymousId = (): string => {
  const storageKey = 'analytics_session_id';
  let sessionId = sessionStorage.getItem(storageKey);
  
  if (!sessionId) {
    sessionId = `anon_${Date.now()}_${Math.random().toString(36).substring(2, 15)}`;
    sessionStorage.setItem(storageKey, sessionId);
  }
  
  return sessionId;
};

// Device/Browser-Erkennung
const getDeviceInfo = () => {
  const ua = navigator.userAgent;
  const isMobile = /Mobile|Android|iPhone|iPad|iPod/.test(ua);
  
  let browser = 'Other';
  if (ua.includes('Chrome')) browser = 'Chrome';
  else if (ua.includes('Firefox')) browser = 'Firefox';
  else if (ua.includes('Safari')) browser = 'Safari';
  else if (ua.includes('Edge')) browser = 'Edge';
  
  return {
    device: isMobile ? 'mobile' : 'desktop',
    browser
  };
};

// Event tracken
export const trackEvent = async (eventName: string, eventData?: any) => {
  try {
    const { device, browser } = getDeviceInfo();
    
    await api.post('/analytics/event', {
      eventName,
      eventData: eventData ? JSON.stringify(eventData) : null,
      anonymousId: getAnonymousId(),
      device,
      browser
    });
  } catch (error) {
    console.debug('Event tracking failed:', error);
  }
};

// Vordefinierte Events
export const Analytics = {
  // Transaktionen
  transactionCreated: (category: string, amount: number) => 
    trackEvent('transaction_created', { category, amount }),
  
  transactionDeleted: () => 
    trackEvent('transaction_deleted'),
  
  // Receipt Scanner
  receiptScanned: (success: boolean) => 
    trackEvent('receipt_scanned', { success }),
  
  receiptSaved: (hasOCR: boolean) => 
    trackEvent('receipt_saved', { hasOCR }),
  
  // Accounts
  accountCreated: (type: string) => 
    trackEvent('account_created', { type }),
  
  accountDeleted: () => 
    trackEvent('account_deleted'),
  
  // Schulden
  debtCreated: (type: string) => 
    trackEvent('debt_created', { type }),
  
  debtDeleted: () => 
    trackEvent('debt_deleted'),
  
  debtPaymentMade: (amount: number) => 
    trackEvent('debt_payment', { amount }),
  
  // Abonnements
  subscriptionCreated: (category: string, amount: number) => 
    trackEvent('subscription_created', { category, amount }),
  
  subscriptionDeleted: () => 
    trackEvent('subscription_deleted'),
  
  subscriptionCancelled: () => 
    trackEvent('subscription_cancelled'),
  
  // User Actions
  userRegistered: () => 
    trackEvent('user_registered'),
  
  userLogin: (isNewUser: boolean) => 
    trackEvent('user_login', { isNewUser }),
  
  // Features
  merchantMappingCreated: (category: string) => 
    trackEvent('merchant_mapping_created', { category }),
  
  customCategoryCreated: () => 
    trackEvent('custom_category_created')
};
